<template>
  <header class="stats-header">
    <!-- Heart Rate Above 80% -->
    <h5 class="fa-pull-left" v-show="currentMetric === sessionMetrics.TIME_ABOVE_80_PERCENT_HR">
      <img class="stats-img" src="@/assets/images/activity/hr-icon.png" alt="distance icon">
      {{ $t('CALENDAR_ACTIVITY.activityCharts.chartHeader.timeAbove80') }}
    </h5>
    <!-- Active Participation -->
    <h5 class="fa-pull-left" v-show="currentMetric === sessionMetrics.AP">
      <img class="stats-img" src="@/assets/images/activity/active-participation-icon.png" alt="distance icon">
      {{ $t('CALENDAR_ACTIVITY.activityCharts.chartHeader.ap') }}
    </h5>
    <!-- Workload -->
    <h5 class="fa-pull-left" v-show="currentMetric === sessionMetrics.WORKLOAD">
      <img class="stats-img" src="@/assets/images/activity/workload-icon.png" alt="distance icon">
      {{ $t('CALENDAR_ACTIVITY.activityCharts.chartHeader.workload') }}
    </h5>
    <div class="switch-control-row fa-pull-right" v-show="currentMetric === sessionMetrics.TIME_ABOVE_80_PERCENT_HR">
      <div class="row-content">
        <div class="row-content-item">
          <div class="btn-group calendar-view-filter switch-btn-group switch-btn-group-orange" @click="switchHrChartUnitAndLog">
            <label class="btn" 
              :class="{'active': hrChartUnit == hrUnits.PERCENTAGE}">%</label>
            <label class="btn" 
              :class="{'active': hrChartUnit == hrUnits.BPM}">{{ $t('CALENDAR_ACTIVITY.activityCharts.chartHeader.bpm') }}</label>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { 
  SESSION_METRICS, 
  TIME_ABOVE_80_PERCENT_HR_UNITS, 
  DISTANCE_ZONES_UNITS
} from '@/constants/SessionConsts'

export default {
  name: 'ChartHeader',
  props: [ 
    'currentMetric',
    'hrChartUnit',
    'changeHrChartUnit',
    'distanceChartUnit',
    'changeDistanceChartUnit'
  ],
  data () {
    return {
      sessionMetrics: SESSION_METRICS,
      hrUnits: TIME_ABOVE_80_PERCENT_HR_UNITS,
      distanceUnits: DISTANCE_ZONES_UNITS
    }
  },
  methods: {
    switchHrChartUnitAndLog () {
      const newUnit = this.hrChartUnit === this.hrUnits.PERCENTAGE ? this.hrUnits.BPM : this.hrUnits.PERCENTAGE
      this.changeHrChartUnit(newUnit)
      this.$amplitude.logEvent('pwa: change activity hr chart unit', {unit: newUnit})
    },
    // switchDistanceChartUnit () {
    //   const newUnit = this.distanceChartUnit === this.distanceUnits.PERCENTAGE ? this.distanceUnits.METERS : this.distanceUnits.PERCENTAGE
    //   this.changeDistanceChartUnit(newUnit)
    // }
  }
}
</script>

<style lang="scss" scoped>
  .stats-header {
    display: inline-block;
    width: 100%;
    color: $mid-gray;
    margin-top: 20px;

    h5 {
      font-weight: 700;
      font-size: 14px;
    }

    .stats-img {
      margin-right: 10px;
    }

    .metric {
      display: none;
    }

    .legend {
      .legend-item {
        display: inline-block;
        margin-left: 20px;

        &:first-child {
          margin-left: 0;
        }

        .circle {
          display: inline-block;
          width: 13px;
          height: 13px;
          background-color: $mid-gray;
          border-radius: 50%;
          position: relative;
          top: 2px;
          margin-right: 2px;

          &.empty {
            background-color: $wood-smoke;
            border: 1px solid $mid-gray;
          }

          &.empty.white-border {
            border: 1px solid $white;
          }
        }
      }
    }
  }
</style>

